import React from "react";

export function WTextBlock({children}: { children: React.ReactNode[] }) {
    return <div>{children}</div>
}